import * as React from "react";

export class SportHeaderName extends React.Component < {
    label : string,
    count?: number,
    shouldShowEventsCount: boolean
}, {} > {

    render() {
        return (
            <div className="rj-sports-multiview__sport-header-name">
                {this.props.shouldShowEventsCount && (this.props.count !== undefined  && <span className="rj-sports-multiview__sport-header-name-event-counter">({this.props.count})</span>)}
                <span className="rj-sports-multiview__sport-header-name-text">{this.props.label}</span>
                {this.props.children}
            </div>
        )
    }
}